// Parse a 3-segment NATS subject `{tenant}.{site}.{systemId}.<eventTopic…>`
// exactly once at the envelope boundary, then reuse the parsed fields
// downstream. Doing this here removes a class of off-by-one bugs caused
// by selectors splitting `subject.split('.')` differently per call site.

export interface ParsedSubject {
  tenant: string;
  site: string;
  systemId: string;
  eventTopic: string;
}

const SUBJECT_RE = /^([^.]+)\.([^.]+)\.([^.]+)\.(.+)$/;

export function parseSubject(s: string): ParsedSubject | null {
  const m = SUBJECT_RE.exec(s);
  if (!m) return null;
  return { tenant: m[1], site: m[2], systemId: m[3], eventTopic: m[4] };
}
